import Vue from "vue";
import VueRouter, { RouteConfig } from "vue-router";
import Admin from "@/views/admin/Admin.vue";
import Login from "@/views/Login.vue";
import InvalidAccount from "@/views/error/InvalidAccount.vue";
import ErrorAccount from "@/views/error/ErrorAccount.vue";
import SystemMaintenance from "@/views/error/SystemMaintenance.vue";
import MySchedule from "@/views/schedule/MyScheduleView.vue"
import Profile from "@/views/profile/Profile.vue";
import NProgress from "nprogress";
import "../css/nprogress.css";

import store from '../store/index'
import { vuexOidcCreateRouterMiddleware } from 'vuex-oidc'

Vue.use(VueRouter);

const routes: Array<RouteConfig> = [
    {
        path: "/",
        redirect: '/schedule'
    },
    {
        path: '/callback',
        component: Login
    },
    {
        path: '/schedule',
        component: MySchedule,
        props: { viewFlag: 'CalView' }
    },
    {
        path: '/departmentView',
        component: MySchedule,
        props: { viewFlag: 'DeptView' }
    },
    {
        path: '/profile',
        component: Profile
    },
    {
        path: '/admin',
        component: Admin
    },
    {
        path: '/invalidaccount',
        component: InvalidAccount
    },
    {
        path: '/erroraccount',
        component: ErrorAccount
    }
    ,
    {
        path: '/systemmaintenance',
        component: SystemMaintenance
    }
];

const router = new VueRouter({
    mode: "history",
    routes
});

router.beforeEach(vuexOidcCreateRouterMiddleware(store))

router.beforeResolve((to, from, next) => {
    // If this isn't an initial page load.
    if (to.path) {
        // Start the route progress bar.
        NProgress.start()
    }
    next()
})

router.afterEach((to, from) => {
    // Complete the animation of the route progress bar.
    NProgress.done()
})

export default router;
